var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShieldNewWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 39,
    viewBox: "0 0 29 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8846 6.06924C21.7108 6.06924 15.3127 0.346494 15.2493 0.289163C14.8241 -0.0963878 14.1759 -0.0963878 13.7507 0.289163C13.687 0.34694 7.30562 6.06924 1.11538 6.06924C0.499395 6.06924 0 6.56863 0 7.18462V20.5423C0 31.3633 8.04832 35.6873 14.1022 37.9985C14.2303 38.0474 14.3651 38.0718 14.5 38.0718C14.6349 38.0718 14.7697 38.0473 14.8978 37.9985C23.3862 34.7579 29 29.703 29 20.5423V7.18462C29 6.56863 28.5006 6.06924 27.8846 6.06924Z",
    fill: "url(#paint0_linear_413_11691gg)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_413_11691gg",
    x1: 14.5,
    y1: 38.0718,
    x2: 14.5,
    y2: -0.000018154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#0065FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791667,
    stopColor: "#4B93FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldNewWallet);
export default __webpack_public_path__ + "static/media/ShieldNewWallet.d5dfdcc036706bebab417b9f44d124ff.svg";
export { ForwardRef as ReactComponent };